module.exports = __webpack_public_path__ + "img/plus.653d5a37.svg";